import cache from './cache';
import system from './system'
export default {
    getToken() {
        return localStorage.getItem(system.token)
    },
    setToken(token) {
        return localStorage.setItem(system.token,token)
    },
    removeToken() {
        return localStorage.removeItem(system.token)
    }
}
